import React from 'react';
import MenuBar from '../DataViewer/MenuBar/MenuBar';
import { Box } from '@mui/material';
interface ILayoutProps {
  children: React.ReactNode;
}
function Layout({ children }: ILayoutProps) {
  const disableEdit = false;
  return (
    <Box
      sx={{
        height: '100svh',
        overflow: 'hidden',
      }}
    >
      <Box style={{ borderBottom: '2px solid rgba(224, 224, 224, 1)' }}>
        <MenuBar from="dataSet" disableEdit={disableEdit} />
      </Box>
      <Box sx={{ height: 'calc(100vh - 42px)', overflow: 'hidden' }}>{children}</Box>
    </Box>
  );
}

export default Layout;
